import { Field } from "src/app/interfaces/field";
import { ChartsInterface } from "./charts"
import { MiniCardInterface } from "./minicard"
import { TableInterface } from "./table"
import { GridsterConfig, GridsterItem } from "angular-gridster2"
import { ApplyColumnStateParams, ColumnState } from "@ag-grid-community/core";
import { FilterParam } from "src/app/interfaces/filter-param";
import { FormGroup } from "@angular/forms";

/**
 * CONTRATO DE PERSISTÊNCIA: este tipo é serializado em
 * Mktpdashboard.EXPRESSION e editado cru pelo "modo avançado".
 * Mudanças precisam ser ADITIVAS (dashboards em produção continuam
 * carregando). Estado runtime NUNCA entra aqui — ver dashboard-serializer.ts.
 */
export interface DashBoardInterface{
    iddashboard:number;
    tabName:string;
    tabTitle:string;
    title?:string;
    /** exibe a barra de título/ações da aba fora do modo edição */
    showToolbar?:boolean;
    options?:GridsterConfig,
    filter?:FilterParam[],
    gadGets:GadGetInterface[]
}

export interface GadGetInterface{
    type:string,
    name:string,
    gridsterItem:GridsterItem,
    minicard?:MiniCardInterface,
    chart?:ChartsInterface,
    table?:TableInterface,
}

export interface DashBoardUserConfigInterface{
    columnState?:ColumnState[],
}


export enum DashBoardTypeEnum{
    table = "table",
    minicard = "minicard",
    chart =  "chart"
}